/**
 * Stepper Component - Component Definition
 * ========================================
 */

import angular, { IModule, IComponentOptions } from 'angular';

import { StepperController } from './controller';
import { STEPPER_TEMPLATE } from './template';
import { SIZES, BASE_CLASSES, ICONS, DEFAULTS, StepperSize } from './constants';

export interface IStepperComponentBindings {
  label?: string;
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
  size?: StepperSize;
  ariaLabel?: string;
  onChange?: (args: { value: number }) => void;
}

export const stepperComponentDefinition: IComponentOptions = {
  template: STEPPER_TEMPLATE,
  controller: StepperController,
  require: { ngModelCtrl: '?ngModel' },
  // Slot nombrado: <ec-label> dentro del componente.
  transclude: { labelSlot: '?ecLabel' },
  bindings: {
    label: '@',
    min: '<',
    max: '<',
    step: '<',
    disabled: '<',
    size: '@',
    ariaLabel: '@',
    onChange: '&?'
  }
};

export const MODULE_NAME = 'ec.stepper';

const stepperModule: IModule = angular
  .module(MODULE_NAME, ['ngSanitize'])
  .component('ecStepper', stepperComponentDefinition);

export { StepperController, STEPPER_TEMPLATE, SIZES, BASE_CLASSES, ICONS, DEFAULTS };
export type { StepperSize } from './constants';
export default stepperModule;
